import * as React from 'react';
import { useSelector } from 'react-redux';
import { orgPlanSelector } from '../../../redux/app/selectors/organization';

interface InvoiceSectionProps {
  handleUpdateCreditCardClick: () => void;
  handleInvoicesClick: () => void;
}

export const InvoiceSection = ({
  handleUpdateCreditCardClick,
  handleInvoicesClick,
}: InvoiceSectionProps) => {
  const plan = useSelector(orgPlanSelector);
  const isTrialPlan = plan === 'trial-plan-4';

  return (
    <div id="invoice-section" className="body mb-10">
      <p className="fsz-16 bold-900 mb-5">Customer Portal</p>
      <div className="content flex justify-between">
        <div className="col-left">
          <p className="fsz-13 mb-5">See your invoice history and update billing information in our customer portal.</p>
        </div>
        <div className="buttons-container flex">
          <button
            type="button"
            className="button sand mr-10"
            onClick={handleUpdateCreditCardClick}
            disabled={isTrialPlan}
          >
            Update Credit Card
          </button>
          <button
            type="button"
            className="button sand"
            onClick={handleInvoicesClick}
            disabled={isTrialPlan}
          >
            View Invoices
          </button>
        </div>
      </div>
    </div>
  );
};
